import React, { useState } from "react";
import Footer from "./Footer";
import { useSpring, animated, config } from "@react-spring/web";
import { Image , useCursor} from "@react-three/drei";
import TextComponent from "./TextComponent";
import { Flex, Box } from "@react-three/flex";

export default function Contacto({isMobile}) {
  const [HoveredIcon, setHoveredIcon] = useState(0);
  const {
    opacity,
    justifyContent,
    alignItems,
    flexDirection,
    display,
    height,
    width,
  } = useSpring({
    config: config.slow,
    from: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      opacity: 0,
    },
    to: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",

      opacity: 1,
    },
    delay: 300,
  });

  const mainContainer = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const container = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100vw",
    height: "60vh",
  };

  // object called titleContainer with an absolute position and a center alignment
  const titleContainer = {
    position: "absolute",
    // align center
    left: "50%",
    top: "43%",
    transform: "translate(-50%, -50%)",
    // background: "white",
    // to upper case
    textTransform: "uppercase",
    fontSize: "1.6rem",
    zIndex: -1,
  };

  const iconContainer = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: isMobile ? "10rem" : "20rem",
    height: "20rem",
    margin: isMobile ? "1rem" : "3rem",
    cursor: "pointer",
  };

  const openTab = (url) => {
    window.open(url, "_blank");
  };

  // component called TwitterComponent that return a Drei Image component
  const TwitterComponent = () => {
    const [Hovered, setHovered] = useState(false);
    useCursor(Hovered /*'pointer', 'auto'*/);

    const openTab = () => {
      window.open("https://twitter.com/LosPixelReapers", "_blank");
    };

    return (
      <Image
        url="/twitter.png"
        position={[0, 0, 0]}
        scale={isMobile ? [0.5,0.5,0.5] :  [1, 1, 1]}
        transparent={true}
        onPointerEnter={() => setHovered(true)}
        onPointerOut={() => setHovered(false)}
        onPointerDown={() => {
          openTab();
        }}      />
    );
  };
  const PhoneComponent = () => {
    return (
      <Image
        url="/phone.png"
        position={[0, -1.4, 0]}
        scale={isMobile ? [0.5,0.5,0.5] :  [1, 1, 1]}
        transparent={true}
        // onClick={() => openTab("https://twitter.com/kevin_ortiz_")}
      />
    );
  };

  const CopyrightComponent = () => {
    return (
      <Image
        url="/copyright.png"
        position={[0, -1.3, 0]}
        scale={isMobile ? [1,0.25, 0.5] : [2, 0.5, 1]}
        
        transparent={true}
        // onClick={() => openTab("https://twitter.com/kevin_ortiz_")}
      />
    );
  };

  return (
    <>
      <TextComponent
        weight={"bold"}
        fs={isMobile ? 0.08 : 0.3}
        txt={"CONTACTO"}
        position={[0, isMobile ? 0.5 : 1.5, 0]}
        rotation={[0, 0, 0]}
      />

      <Box flexDirection={"row"}>
        <TwitterComponent />
        {/* <PhoneComponent /> */}
        <TextComponent
          weight={"light"}
          fs={isMobile ? 0.08 :0.16}
          txt={"@losPixelReapers"}
          position={[0, isMobile ? -0.3 :  -0.58, 0]}
          rotation={[0, 0, 0]}
        />
        {/* <TextComponent
          weight={"light"}
          fs={isMobile ? 0.08 :0.16}
          txt={"77-47-41-92"}
          position={[0, isMobile ? -1.7 : -1.9, 0]}
          rotation={[0, 0, 0]}
        /> */}
        <CopyrightComponent />
      </Box>
    </>
  );
}
